import * as React from "react";
import { cn } from "@/lib/utils";

export interface LoaderProps {
  label?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeMap = {
  sm: "h-6 w-6 border-2",
  md: "h-10 w-10 border-2",
  lg: "h-14 w-14 border-[3px]",
};

export function Loader({ label, size = "md", className }: LoaderProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center", className)}>
      <span
        className={cn(
          "rounded-full animate-spin border-muted border-t-primary",
          sizeMap[size]
        )}
        aria-hidden
      />
      {label && (
        <p className="mt-3 text-sm text-muted-foreground">{label}</p>
      )}
    </div>
  );
}

/** Full-screen loader overlay — convenience wrapper for page-level loading */
export function FullScreenLoader({ label = "Loading…" }: { label?: string }) {
  return (
        <div className="min-h-dvh flex items-center justify-center bg-surface">
      <Loader size="lg" label={label} />
    </div>
  );
}
